export const NO_LOAD_THRESHOLD = 6969;
export const GARBAGE_THRESHOLD = 500;
export const TEMPO_NUMERATOR = 60000;
export const INITIAL_HEALTH = 10;
export const RECORD_KEY_CODE = 'Enter';
export const SPECIAL_CHANCE = 1 / 1000;
export const SPECIAL_SCORE_THRESHOLD = 0.9;
export const MIN_SPECIAL_POSSIBLE_POINTS = 1024;

export const POINTS = {
  perfect: 32,
  good: 16,
  okay: 8,
  bad: 4,
  awful: 2,
  pre: 1,
  miss: 0,
  wrong: 0,
};

export const DAMAGE = {
  perfect: -1,
  good: 0,
  okay: 0,
  bad: 0,
  awful: 0,
  pre: 0,
  miss: 1,
  wrong: 2,
};
